__turbopack_context__.v({
  "actions": "Header-module-scss-module__dzKH6G__actions",
  "circle": "Header-module-scss-module__dzKH6G__circle",
  "cornerActions": "Header-module-scss-module__dzKH6G__cornerActions",
  "cornerActionsButtons": "Header-module-scss-module__dzKH6G__cornerActionsButtons",
  "cover": "Header-module-scss-module__dzKH6G__cover",
  "coverContent": "Header-module-scss-module__dzKH6G__coverContent",
  "coverWrapper": "Header-module-scss-module__dzKH6G__coverWrapper",
  "identity": "Header-module-scss-module__dzKH6G__identity",
  "location": "Header-module-scss-module__dzKH6G__location",
  "logo": "Header-module-scss-module__dzKH6G__logo",
  "meta": "Header-module-scss-module__dzKH6G__meta",
  "name": "Header-module-scss-module__dzKH6G__name",
  "nameBlock": "Header-module-scss-module__dzKH6G__nameBlock",
});
